__turbopack_context__.v({
  "answer": "styles-module-scss-module__wbL-La__answer",
  "answerInner": "styles-module-scss-module__wbL-La__answerInner",
  "answerWrap": "styles-module-scss-module__wbL-La__answerWrap",
  "answerWrapClosed": "styles-module-scss-module__wbL-La__answerWrapClosed",
  "answerWrapOpen": "styles-module-scss-module__wbL-La__answerWrapOpen",
  "button": "styles-module-scss-module__wbL-La__button",
  "buttonContact": "styles-module-scss-module__wbL-La__buttonContact",
  "buttonFaq": "styles-module-scss-module__wbL-La__buttonFaq",
  "card": "styles-module-scss-module__wbL-La__card",
  "cardActive": "styles-module-scss-module__wbL-La__cardActive",
  "cardIdle": "styles-module-scss-module__wbL-La__cardIdle",
  "content": "styles-module-scss-module__wbL-La__content",
  "enter": "styles-module-scss-module__wbL-La__enter",
  "exit": "styles-module-scss-module__wbL-La__exit",
  "fade-in": "styles-module-scss-module__wbL-La__fade-in",
  "fade-out": "styles-module-scss-module__wbL-La__fade-out",
  "fade-out-80": "styles-module-scss-module__wbL-La__fade-out-80",
  "footer": "styles-module-scss-module__wbL-La__footer",
  "icon": "styles-module-scss-module__wbL-La__icon",
  "iconBarHorizontal": "styles-module-scss-module__wbL-La__iconBarHorizontal",
  "iconBarVertical": "styles-module-scss-module__wbL-La__iconBarVertical",
  "list": "styles-module-scss-module__wbL-La__list",
  "outer": "styles-module-scss-module__wbL-La__outer",
  "panel": "styles-module-scss-module__wbL-La__panel",
  "panelWrap": "styles-module-scss-module__wbL-La__panelWrap",
  "question": "styles-module-scss-module__wbL-La__question",
  "section": "styles-module-scss-module__wbL-La__section",
  "slide-in-from-bottom": "styles-module-scss-module__wbL-La__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__wbL-La__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__wbL-La__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__wbL-La__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__wbL-La__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__wbL-La__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__wbL-La__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__wbL-La__slide-out-to-top",
  "title": "styles-module-scss-module__wbL-La__title",
  "titleWrap": "styles-module-scss-module__wbL-La__titleWrap",
  "toggle": "styles-module-scss-module__wbL-La__toggle",
  "toggleActive": "styles-module-scss-module__wbL-La__toggleActive",
  "trigger": "styles-module-scss-module__wbL-La__trigger",
  "zoom-in": "styles-module-scss-module__wbL-La__zoom-in",
  "zoom-out": "styles-module-scss-module__wbL-La__zoom-out",
});
